module.exports = __webpack_public_path__ + "static/img/xszy.68f05b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xszy.png
// module id = iYtw
// module chunks = 4